// Business Consulting line items with subtotal / discount / tax / total -
// the same figures the PDF prints. (2026-10-02)
export default function ConsultingLines({ lines, invoice }) {
  const money = n => '$' + Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const subtotal = lines.reduce((s, l) => s + Number(l.amount || 0), 0);
  return (
    <div style={{ marginBottom: 16 }}>
      <h4 style={{ fontSize: 13, fontWeight: 700, marginBottom: 8 }}>Line items</h4>
      <table className="data-table" style={{ fontSize: 12 }}>
        <thead><tr><th>#</th><th>Description</th><th>Period</th><th style={{ textAlign: 'right' }}>Amount</th></tr></thead>
        <tbody>
          {lines.map(l => (
            <tr key={l.id}>
              <td>{l.line_no}</td>
              <td>{l.description}</td>
              <td>{l.period_start || l.period_end ? `${l.period_start || '…'} – ${l.period_end || '…'}` : '—'}</td>
              <td style={{ textAlign: 'right' }}>{money(l.amount)}</td>
            </tr>
          ))}
          <tr><td colSpan={3} style={{ textAlign: 'right', color: 'var(--muted)' }}>Subtotal</td><td style={{ textAlign: 'right' }}>{money(subtotal)}</td></tr>
          <tr><td colSpan={3} style={{ textAlign: 'right', color: 'var(--muted)' }}>Discount</td><td style={{ textAlign: 'right' }}>{invoice.discount_amount ? '-' + money(invoice.discount_amount) : 'N/A'}</td></tr>
          <tr><td colSpan={3} style={{ textAlign: 'right', color: 'var(--muted)' }}>Tax</td><td style={{ textAlign: 'right' }}>{invoice.tax_amount ? money(invoice.tax_amount) : 'N/A'}</td></tr>
          <tr><td colSpan={3} style={{ textAlign: 'right', fontWeight: 700 }}>Total</td><td style={{ textAlign: 'right', fontWeight: 700 }}>{money(invoice.amount)}</td></tr>
        </tbody>
      </table>
    </div>
  );
}
